import { inject, injectable } from 'inversify'
import type { Resolvable } from '@/services/resolvers/types'
import { SERVICE_TYPES } from '@/core/container/types'
import type RouterService from '@/services/route/routerService'
import type EmailCampaignDomainService from '@/services/domain/campaign/emailCampaignDomainService'
import { TmApiNotFoundError } from '@/core/error/transport/tmApiNotFoundError'
import { TmApiAccessError } from '@/core/error/transport/tmApiAccessError'
import type EmailCampaignDomainsPreloaderService from '@/services/preloaders/emailCampaignDomainsPreloaderService'
import { UserSettingsRoutes } from '@/routes/user/settings'

@injectable()
export default class SettingsEmailCampaignDomainsRouteResolverService implements Resolvable {
  constructor(
    @inject(SERVICE_TYPES.RouterService) protected readonly routerService: RouterService,
    @inject(SERVICE_TYPES.EmailCampaignDomainService)
    protected readonly emailCampaignDomainService: EmailCampaignDomainService,
    @inject(SERVICE_TYPES.EmailCampaignDomainsPreloaderService)
    protected readonly emailCampaignDomainsPreloaderService: EmailCampaignDomainsPreloaderService,
  ) {}

  public async resolve(): Promise<void> {
    try {
      await this.emailCampaignDomainsPreloaderService.preload()
      const domains = this.emailCampaignDomainService.findAll()
      const currentRoute = this.routerService.getCurrentRoute()
      if (
        !domains.length &&
        currentRoute.name !== UserSettingsRoutes.EmailFlow &&
        currentRoute.name !== UserSettingsRoutes.Email
      ) {
        await this.routerService.replace({
          name: UserSettingsRoutes.Email,
          query: currentRoute.query,
        })
      }
    } catch (e) {
      if (e instanceof TmApiNotFoundError || e instanceof TmApiAccessError) {
        const currentRoute = this.routerService.getCurrentRoute()
        await this.routerService.replace({
          name: UserSettingsRoutes.Email,
          query: currentRoute.query,
        })
        return
      }
      throw e
    }
  }
}
